import React from 'react'
import withDevicesForm from 'hocs/extends/withDevicesForm'
import FormMultiImagesWithCustom from 'components/forms/image/FormMultiImagesWithCustom'
import { updateObject } from 'helpers/objectHelpers'

const FormLevelCBanner = withDevicesForm(
  ({ value, onChange }) => {
    return (
      <FormMultiImagesWithCustom
        value={value.images || []}
        onChange={(images) => {
          onChange(updateObject(value, { images }))
        }}
      />
    )
  },
)

export default FormLevelCBanner



// WEBPACK FOOTER //
// ./src/components/forms/FormLevelCBanner.js